import { Modal, Form, Input, App as AntdApp } from "antd";
import { api, readErrorMessage } from "../../lib/api";

export default function ChangePasswordModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [form] = Form.useForm();
  const { message } = AntdApp.useApp();

  const onSubmit = async () => {
    const values = await form.validateFields();
    if (values.newPassword !== values.confirmPassword) {
      message.error("Xác nhận mật khẩu không khớp");
      return;
    }
    const res = await api.api.auth["change-password"].$post({
      json: { currentPassword: values.currentPassword, newPassword: values.newPassword },
    });
    if (!res.ok) {
      message.error(await readErrorMessage(res));
      return;
    }
    message.success("Đã đổi mật khẩu");
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Đổi mật khẩu"
      open={open}
      onOk={onSubmit}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okText="Lưu"
      cancelText="Huỷ"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Mật khẩu hiện tại"
          name="currentPassword"
          rules={[{ required: true, message: "Nhập mật khẩu hiện tại" }]}
        >
          <Input.Password autoFocus />
        </Form.Item>
        <Form.Item
          label="Mật khẩu mới"
          name="newPassword"
          rules={[{ required: true, min: 6, message: "Tối thiểu 6 ký tự" }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Xác nhận mật khẩu mới"
          name="confirmPassword"
          rules={[{ required: true, min: 6 }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
}
